// import PieChartCard from "views/admin/default/components/PieChartCard";
// import { IoDocuments } from "react-icons/io5";
// import { MdBarChart, MdDashboard } from "react-icons/md";

// import Widget from "components/widget/Widget";

// import DailyTraffic from "views/admin/default/components/DailyTraffic";
// import { IoMdThermometer } from "react-icons/io";
// import { useEffect, useState } from "react";
// import { getAllAnalytics, getFrequencyData } from "../../../redux/action/index";
// import { useDispatch } from "react-redux";
// import { BiRefresh } from "react-icons/bi";
// import { ConvertDateToEpoch } from "utils/functions";
// import LineChart from "components/charts/LineChart";
// import WeeklyRevenue from "./components/WeeklyRevenue";
// import TotalSpent from "./components/TotalSpent";
// import TaskCard from "./components/TaskCard";
// import CheckTable from "./components/CheckTable";
// import ComplexTable from "./components/ComplexTable";

// const Dashboard = () => {
//   const [startDate, setStartDate] = useState();
//   const [endDate, setEndDate] = useState();
//   const [shimmer, setShimmer] = useState(false);
//   const [analyticsData, setAnalyticsData] = useState([]);
//   const [frequencyData, setFrequencyData] = useState([]);
//   const submitting = false;
//   const dispatch = useDispatch();
//   const loading = false;
//   const handleGetAnalytics = () => {
//     setShimmer(true);
//     dispatch(
//       getAllAnalytics({
//         startDate: ConvertDateToEpoch(startDate),
//         endDate: ConvertDateToEpoch(endDate),
//       })
//     )
//       .then((res) => {
//         setAnalyticsData(res.data);
//         setShimmer(false);
//       })
//       .catch((err) => {
//         setAnalyticsData([]);
//         console.log("Get Err:", err);
//         setShimmer(false);
//       });
//   };
//   const handleGetFrequencyData = () => {
//     setShimmer(true);
//     dispatch(
//       getFrequencyData({
//         startDate: ConvertDateToEpoch(startDate),
//         endDate: ConvertDateToEpoch(endDate),
//       })
//     )
//       .then((res) => {
//         setFrequencyData(res?.data?.data);
//         setShimmer(false);
//       })
//       .catch((err) => {
//         setFrequencyData([]);
//         console.log("Get Err:", err);
//         setShimmer(false);
//       });
//   };
//   useEffect(() => {
//     handleGetAnalytics();
//     handleGetFrequencyData();
//   }, []);
//   const handleClickGo = () => {
//     handleGetAnalytics();
//     handleGetFrequencyData();
//   };
//   const resetAnalytics = () => {
//     setShimmer(true);
//     dispatch(getAllAnalytics({}))
//       .then((res) => {
//         setAnalyticsData(res.data);
//         setShimmer(false);
//       })
//       .catch((err) => {
//         console.log("Get Err:", err);
//         setShimmer(false);
//       });
//   };
//   const resetFrequencyData = () => {
//     setShimmer(true);
//     dispatch(getFrequencyData({}))
//       .then((res) => {
//         setFrequencyData(res.data);
//         setShimmer(false);
//       })
//       .catch((err) => {
//         setFrequencyData([]);
//         console.log("Get Err:", err);
//         setShimmer(false);
//       });
//   };
//   const resetFilters = () => {
//     setStartDate("");
//     setEndDate("");
//     resetAnalytics();
//     resetFrequencyData();
//   };
//   return (
//     <div>
//       <div className="mr-2 mt-3 flex w-full justify-end gap-2">
//         <div className="">
//           <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
//             Start Date
//           </label>
//           <input
//             type="date"
//             value={startDate}
//             onChange={(e) => {
//               const selectedStartDate = e.target.value;
//               setStartDate(selectedStartDate);

//               // Reset the end date if it is less than the start date
//               if (endDate && selectedStartDate > endDate) {
//                 setEndDate("");
//               }
//             }}
//             className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
//             max={endDate} // The start date cannot be later than the selected end date
//           />
//         </div>

//         <div>
//           <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
//             End Date
//           </label>
//           <input
//             type="date"
//             value={endDate}
//             onChange={(e) => {
//               const selectedEndDate = e.target.value;
//               setEndDate(selectedEndDate);
//             }}
//             disabled={!startDate} // Disable the end date field until the start date is selected
//             min={startDate} // The end date cannot be earlier than the selected start date
//             className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
//           />
//         </div>

//         <div className="flex items-end justify-end">
//           <button
//             onClick={handleClickGo}
//             className={`linear  h-[45px] rounded-xl bg-brand-500 px-6 text-base font-medium text-white hover:bg-brand-600 active:bg-brand-800 disabled:bg-gray-400 ${
//               submitting || loading ? "cursor-not-allowed" : null
//             }`}
//           >
//             Go
//           </button>
//         </div>
//         <div className="flex items-end justify-end">
//           <button
//             onClick={() => {
//               resetFilters();
//             }}
//             className="linear  flex h-[45px] items-center justify-center gap-1 rounded-xl border border-brand-600 px-[8px] py-[10px] text-sm font-medium text-brand-600 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
//           >
//             <BiRefresh size={18} /> Reset
//           </button>
//         </div>
//       </div>
//       <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-5 2xl:grid-cols-5 3xl:grid-cols-5">
//         <Widget
//           icon={<MdBarChart className="h-7 w-7" />}
//           title={"Total Complaints"}
//           subtitle={
//             analyticsData?.data?.complaint_stat?.all_registered_complaints || 0
//           }
//         />
//         <Widget
//           icon={<MdDashboard className="h-6 w-6" />}
//           title={"Active Complaints"}
//           subtitle={analyticsData?.data?.complaint_stat?.active_complaints || 0}
//         />
//         <Widget
//           icon={<MdDashboard className="h-6 w-6" />}
//           title={"Raised Complaints"}
//           subtitle={
//             analyticsData?.data?.complaint_stat?.inactive_complaints || 0
//           }
//         />
//         <Widget
//           icon={<IoDocuments className="h-6 w-6" />}
//           title={"On Hold Complaints"}
//           subtitle={analyticsData?.data?.complaint_stat?.hold_complaints || 0}
//         />
//         <Widget
//           icon={<IoDocuments className="h-6 w-6" />}
//           title={"Closed Complaints"}
//           subtitle={
//             analyticsData?.data?.complaint_stat?.resolved_complaints || 0
//           }
//         />
//       </div>
//       <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
//         <Widget
//           icon={<MdBarChart className="h-7 w-7" />}
//           title={"Total Accounts"}
//           subtitle={
//             analyticsData?.data?.account_stat?.all_registered_accounts || 0
//           }
//         />
//         <Widget
//           icon={<MdDashboard className="h-6 w-6" />}
//           title={"Activated Accounts"}
//           subtitle={analyticsData?.data?.account_stat?.active_accounts || 0}
//         />
//         <Widget
//           icon={<MdBarChart className="h-7 w-7" />}
//           title={"Deactivated Accounts"}
//           subtitle={analyticsData?.data?.account_stat?.inactive_accounts || 0}
//         />
//         <Widget
//           icon={<IoMdThermometer className="h-6 w-6" />}
//           title={"Suspended Accounts"}
//           subtitle={analyticsData?.data?.account_stat?.suspended_accounts || 0}
//         />
//       </div>
//       <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
//         <Widget
//           icon={<MdBarChart className="h-7 w-7" />}
//           title={"Total B & R Complaints"}
//           subtitle={
//             analyticsData?.data?.complaint_stat?.bnr_all_complaints || 0
//           }
//         />
//         <Widget
//           icon={<MdDashboard className="h-6 w-6" />}
//           title={"Total E & M Complaints"}
//           subtitle={
//             analyticsData?.data?.complaint_stat?.enm_all_complaints || 0
//           }
//         />
//         <Widget
//           icon={<MdBarChart className="h-7 w-7" />}
//           title={"Total Miscellaneous Complaints"}
//           subtitle={
//             analyticsData?.data?.complaint_stat?.misc_all_complaints || 0
//           }
//         />
//       </div>
//       <div className="mt-5">
//         <WeeklyRevenue complaint_data={analyticsData?.data} />
//       </div>
//       <div className="mt-5 grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
//         <DailyTraffic frequencyData={frequencyData} />
//         <PieChartCard complaint_data={analyticsData?.data?.complaint_stat} />
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";

import Widget from "components/widget/Widget";
import Shimmer from "components/shimmer/Shimmer"; // Create this component for loading effect
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import { IoMdThermometer } from "react-icons/io";
import { useEffect, useState } from "react";
import { getAllAnalytics, getFrequencyData } from "../../../redux/action/index";
import { useDispatch } from "react-redux";
import { BiRefresh } from "react-icons/bi";
import { ConvertDateToEpoch } from "utils/functions";
import WeeklyRevenue from "./components/WeeklyRevenue";

const Dashboard = () => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [analyticsLoading, setAnalyticsLoading] = useState(true);
  const [frequencyLoading, setFrequencyLoading] = useState(true);

  const [analyticsData, setAnalyticsData] = useState([]);
  const [frequencyData, setFrequencyData] = useState([]);

  const dispatch = useDispatch();
  const submitting = false;

  const loading = false;

  const handleGetAnalytics = () => {
    setAnalyticsLoading(true);
    dispatch(
      getAllAnalytics({
        startDate: ConvertDateToEpoch(startDate),
        endDate: ConvertDateToEpoch(endDate),
      })
    )
      .then((res) => {
        setAnalyticsData(res.data);
        setAnalyticsLoading(false);
      })
      .catch((err) => {
        setAnalyticsData([]);
        setAnalyticsLoading(false);
      });
  };

  const handleGetFrequencyData = () => {
    setFrequencyLoading(true);
    dispatch(
      getFrequencyData({
        startDate: ConvertDateToEpoch(startDate),
        endDate: ConvertDateToEpoch(endDate),
      })
    )
      .then((res) => {
        setFrequencyData(res?.data?.data);
        setFrequencyLoading(false);
      })
      .catch((err) => {
        setFrequencyData([]);
        setFrequencyLoading(false);
      });
  };
  const resetAnalytics = () => {
    setAnalyticsLoading(true);
    dispatch(getAllAnalytics({}))
      .then((res) => {
        setAnalyticsData(res.data);
        setAnalyticsLoading(false);
      })
      .catch((err) => {
        console.log("Get Err:", err);
        setAnalyticsLoading(false);
      });
  };
  const resetFrequencyData = () => {
    setFrequencyLoading(true);
    dispatch(getFrequencyData({}))
      .then((res) => {
        setFrequencyData(res.data);
        setFrequencyLoading(false);
      })
      .catch((err) => {
        setFrequencyData([]);
        console.log("Get Err:", err);
        setFrequencyLoading(false);
      });
  };
  const resetFilters = () => {
    setStartDate("");
    setEndDate("");
    resetAnalytics();
    resetFrequencyData();
  };
  useEffect(() => {
    handleGetAnalytics();
    handleGetFrequencyData();
  }, []);

  const handleClickGo = () => {
    handleGetAnalytics();
    handleGetFrequencyData();
  };

  return (
    <div>
      {/* Date filters and reset */}
      <div className="mr-2 mt-3 flex w-full justify-end gap-2">
        <div className="">
          <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
            Start Date
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => {
              const selectedStartDate = e.target.value;
              setStartDate(selectedStartDate);

              // Reset the end date if it is less than the start date
              if (endDate && selectedStartDate > endDate) {
                setEndDate("");
              }
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
            max={endDate} // The start date cannot be later than the selected end date
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
            End Date
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => {
              const selectedEndDate = e.target.value;
              setEndDate(selectedEndDate);
            }}
            disabled={!startDate} // Disable the end date field until the start date is selected
            min={startDate} // The end date cannot be earlier than the selected start date
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
        </div>

        <div className="flex items-end justify-end">
          <button
            onClick={handleClickGo}
            className={`linear  h-[45px] rounded-xl bg-brand-500 px-6 text-base font-medium text-white hover:bg-brand-600 active:bg-brand-800 disabled:bg-gray-400 ${
              submitting || loading ? "cursor-not-allowed" : null
            }`}
          >
            Go
          </button>
        </div>
        <div className="flex items-end justify-end">
          <button
            onClick={() => {
              resetFilters();
            }}
            className="linear  flex h-[45px] items-center justify-center gap-1 rounded-xl border border-brand-600 px-[8px] py-[10px] text-sm font-medium text-brand-600 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            <BiRefresh size={18} /> Reset
          </button>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-5">
        {/* Total Complaints Widget */}
        {analyticsLoading ? (
          <>
            {" "}
            <Shimmer />
            <Shimmer />
            <Shimmer />
            <Shimmer />
            <Shimmer />
          </>
        ) : (
          <>
            {" "}
            {/* <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-5 2xl:grid-cols-5 3xl:grid-cols-5"> */}
            <Widget
              icon={<MdBarChart className="h-7 w-7" />}
              title={"Total Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat
                  ?.all_registered_complaints || 0
              }
            />
            <Widget
              icon={<MdDashboard className="h-6 w-6" />}
              title={"In Progress Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.active_complaints || 0
              }
            />
            <Widget
              icon={<MdDashboard className="h-6 w-6" />}
              title={"Raised Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.inactive_complaints || 0
              }
            />
            <Widget
              icon={<IoDocuments className="h-6 w-6" />}
              title={"Pending Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.hold_complaints || 0
              }
            />
            <Widget
              icon={<IoDocuments className="h-6 w-6" />}
              title={"Closed Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.resolved_complaints || 0
              }
            />
            {/* </div> */}
          </>
        )}
      </div>
      <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
        {analyticsLoading ? (
          <>
            {" "}
            <Shimmer />
            <Shimmer />
            <Shimmer />
            <Shimmer />
          </>
        ) : (
          <>
            <Widget
              icon={<MdBarChart className="h-7 w-7" />}
              title={"Total Accounts"}
              subtitle={
                analyticsData?.data?.account_stat?.all_registered_accounts || 0
              }
            />
            <Widget
              icon={<MdDashboard className="h-6 w-6" />}
              title={"Activated Accounts"}
              subtitle={analyticsData?.data?.account_stat?.active_accounts || 0}
            />
            <Widget
              icon={<MdBarChart className="h-7 w-7" />}
              title={"Deactivated Accounts"}
              subtitle={
                analyticsData?.data?.account_stat?.inactive_accounts || 0
              }
            />
            <Widget
              icon={<IoMdThermometer className="h-6 w-6" />}
              title={"Suspended Accounts"}
              subtitle={
                analyticsData?.data?.account_stat?.suspended_accounts || 0
              }
            />
          </>
        )}
      </div>
      <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
        {analyticsLoading ? (
          <>
            {" "}
            <Shimmer />
            <Shimmer />
            <Shimmer />
          </>
        ) : (
          <>
            <Widget
              icon={<MdBarChart className="h-7 w-7" />}
              title={"Total B & R Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.bnr_all_complaints || 0
              }
            />
            <Widget
              icon={<MdDashboard className="h-6 w-6" />}
              title={"Total E & M Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.enm_all_complaints || 0
              }
            />
            <Widget
              icon={<MdBarChart className="h-7 w-7" />}
              title={"Total Miscellaneous Complaints"}
              subtitle={
                analyticsData?.data?.complaint_stat?.misc_all_complaints || 0
              }
            />
          </>
        )}
      </div>

      {/* WeeklyRevenue Component */}
      <div className="mt-5">
        {analyticsLoading ? (
          <Shimmer />
        ) : (
          <WeeklyRevenue complaint_data={analyticsData?.data} />
        )}
      </div>

      {/* DailyTraffic and PieChartCard */}
      <div className="mt-5 grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
        {frequencyLoading ? (
          <Shimmer />
        ) : (
          <DailyTraffic frequencyData={frequencyData} />
        )}
        {analyticsLoading ? (
          <Shimmer />
        ) : (
          <PieChartCard complaint_data={analyticsData?.data?.complaint_stat} />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
